module.exports = {"640424100":"香水镇","640424101":"泾河源镇","640424102":"六盘山镇","640424200":"新民乡","640424201":"兴盛乡","640424202":"黄花乡","640424203":"大湾乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640424.json
// module id = 3043
// module chunks = 0